<template>
  <!-- @mouseleave="activeStreet = null" -->
  <!-- :class="sizeMode === 'C' ? 'd-flex f-wrap' : 'f-column'" -->
  <div
    class="ab_history"
    @mouseleave="$emit('active:spot', null)"
    @contextmenu="e => $emit('contextmenu', e)"
    @click="e => $emit('click', e)"
  >
    <div
      v-show="hasOpenAll"
      class="csst csst_nm ab_icon-opener z-index_4"
    >
      <i
        v-if="openSpots.length && sizeMode !== 'C'"
        :class="{ rotated_180_before: allSpotsOpen }"
        class="mdi mdi-chevron-double-down icon_btn transition_03"
        @click.stop="toggleAllOpenSpots"
      />
      <div
        class="csst_content text-nowrap clr-white"
        :style="`position: absolute; top: 1.5rem; right: 0;`"
      >
        {{ allSpotsOpen ? $t('tooltips.hide_all') : $t('tooltips.show_all') }}
      </div>
    </div>
    <div
      v-for="(street, sIdx) in streets"
      :key="`${sIdx}_${street.id}`"
      class="ab_street ha-street-block"
    >
      <div
        v-for="(spot, gIdx) in street.spots"
        :key="`${sIdx}_${gIdx}_${spot.street}_${spot.id}`"
        class="ab_spot-wrapper"
        :class="[
          spot.css_class,
          `ab_spot-wrapper_type_${spot.type}`,
          { 'ab_spot-wrapper_bot': spot.is_bot },
          {
            'ab_spot-wrapper_active': spot.grouped_ids
              ? spot.grouped_ids.includes(replayedSpotId)
              : spot.id === replayedSpotId,
          },
        ]"
        @click="e => $emit('click:spot', { e, spot })"
        @mouseenter="e => $emit('mouseenter:spot', { e, spot })"
      >
        <HaStreetTitle
          v-if="spot.type === 'board'"
          :spot="spot"
          :board="spot.street === 'preflop' ? item.hero.hand : spot.board"
          :hasReal="hasReal"
          :hasSolvedLine="hasSolvedLine"
          :class="{ 'ma-0': street.single }"
        />

        <HaGroupedFolds
          v-if="spot.type === 'grouped_folds'"
          :spot="spot"
        />

        <HaOpponent
          v-if="spot.type === 'player' && !spot.is_hero"
          :showBetsIn="showBetsIn"
          :spot="spot"
        />
        <HaHero
          v-if="spot.type === 'player' && spot.is_hero"
          :spot="spot"
          :open="getOpenSpot(spot)"
          :showBetsIn="showBetsIn"
          :showEvIn="showEvIn"
          @register:open="registerOpenSpot"
          @update:open="updateOpenSpot"
        />
        <HaShowdown
          v-if="spot.type === 'showdown'"
          :hero="item.hero"
          :opponent="item.opponent"
          :hand_hero="item.hero.hand"
          :hand_opponent="item.opponent.hand"
          :hasWinnings="hasWinnings"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue'
import format_mix from '@/mixins/format_mix'
import HaStreetTitle from '@/components/AnalyzeStreetBlocks/HaStreetTitle'
import HaGroupedFolds from '@/components/AnalyzeStreetBlocks/HaGroupedFolds'
import HaOpponent from '@/components/AnalyzeStreetBlocks/HaOpponent'
import HaHero from '@/components/AnalyzeStreetBlocks/HaHero'
import HaShowdown from '@/components/AnalyzeStreetBlocks/HaShowdown'

export default {
  name: 'AnalyzeStreetBlocks',
  components: {
    HaStreetTitle,
    HaGroupedFolds,
    HaOpponent,
    HaHero,
    HaShowdown,
  },
  mixins: [format_mix],
  props: {
    item: {
      default: () => ({
        gameformat: null,
        history_spots: null,
        opponent: null,
        hero: null,
      }),
    },
    hasReal: Boolean,
    showBetsIn: String,
    showEvIn: String,
    hasSolvedLine: Boolean,
    hasWinnings: Boolean,
    hasShowdown: { type: Boolean, default: true },
    replayedSpotId: Number,
    hasOpenAll: { type: Boolean, default: true },
  },
  emits: ['active:spot', 'contextmenu', 'click', 'click:spot', 'mouseenter:spot'],
  data() {
    return {
      sizeMode: 'L',
      activeStreet: 'preflop',
      openSpots: [],
    }
  },
  mounted() {
    nextTick(() => {
      const showAllActions = localStorage.getItem('hh_show_all_actions') === 'true'
      if (showAllActions) {
        this.openSpots = this.openSpots.map(i => ({ ...i, open: true }))
      }
    })
  },
  methods: {
    getOpenSpot(spot) {
      const res = this.openSpots.find(s => s.id === spot.id)
      return !!res?.open
    },
    registerOpenSpot({ id, open }) {
      this.openSpots = [...this.openSpots, { id, open }]
    },
    updateOpenSpot({ id, open }) {
      this.openSpots = this.openSpots.map(i => (id === i.id ? { ...i, open: true } : i))
    },
    toggleAllOpenSpots() {
      if (this.allSpotsOpen) {
        this.openSpots = this.openSpots.map(i => ({ ...i, open: false }))
        localStorage.setItem('hh_show_all_actions', 'false')
      } else {
        this.openSpots = this.openSpots.map(i => ({ ...i, open: true }))
        localStorage.setItem('hh_show_all_actions', 'true')
      }
    },
    getStreetIdx(street) {
      const streets = { preflop: 0, flop: 1, turn: 2, river: 3 }
      return streets[street?.toLowerCase()] || 0
    },
  },
  computed: {
    streets() {
      const hSpots = this.item.history_spots.filter(Boolean)
      const streetSpots = hSpots.reduce((acc, i) => {
        if (i.type === 'board') {
          acc.push(i)
        }
        return acc
      }, [])
      let res = streetSpots.map(sSpot => {
        const { street } = sSpot
        const spots = hSpots.filter(
          i => i.street === street && i.type !== 'board' && i.type !== 'showdown',
        )
        return {
          id: street,
          spots: [sSpot, ...spots],
          single: !spots.length,
        }
      })
      res = res.filter(i => i.spots?.length)
      const showdown = !this.hasShowdown ? null : hSpots.find(i => i.type === 'showdown')
      if (showdown) {
        res.push({
          id: 'showdown',
          spots: [showdown],
        })
      }
      // console.log('AnalyzeStreetBlocks', JSON.parse(JSON.stringify(res)))
      return res
    },
    allSpotsOpen() {
      const res = this.openSpots.every(i => i.open)
      return res
    },
  },
}
</script>

<style lang="scss" scoped>
.ab {
  &_history {
    display: flex;
    flex-direction: column;
    gap: var(--ha-gap);

    cursor: default;
    position: relative;
    padding: 0 0 1rem 0;
  }
  &_icon-opener {
    font-size: 1.25rem;
    z-index: 14;
    position: absolute;
    top: 2.25rem;
    transition: 0.3s;
    right: 0.5rem;
    color: var(--clr-grey-2);
  }
}
</style>
